import { Dialog } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { EditInput, ModalDialog } from '@sistemiv/s-components'
import { DispatchSetAction } from '@sistemiv/s-components/dist/esm/types/types'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useUpdateVariableValue } from '../../repositories/named-values/mutation/update-variable-value'
import { useUpdateVariableName } from '../../repositories/named-values/mutation/update-variable-name.mutation'

const EditNamedValueModal: FC<{
  open: boolean
  setOpen: DispatchSetAction<boolean>
  editingValue: any
  onCancel: () => void
}> = ({ open, setOpen, editingValue, onCancel }) => {
  const [name, setName] = useState(editingValue.name)
  const [value, setValue] = useState(editingValue.value)
  const { org } = useParams()
  const { t } = useTranslation()
  const { mutate: editName } = useUpdateVariableName()
  const { mutate: editValue } = useUpdateVariableValue()

  const handleEditName = (newName: string) => {
    editName(
      {
        name: newName.trim(),
        oldName: name,
        organization: org!,
      },
      {
        onSuccess: () => {
          setName(newName)
        },
        onError: () => {
          setName(name + ' ')
        },
      },
    )
  }
  const handleEditValue = (value: string) => {
    editValue(
      {
        value: value.trim(),
        name: name,
        organization: org!,
      },
      {
        onSuccess: () => {
          setValue(value)
        },
        onError: () => {
          setValue(editingValue.value + ' ')
        },
      },
    )
  }

  return (
    <ModalDialog isOpen={open} setOpen={setOpen} className='!max-w-sm'>
      <Dialog.Title as='h3' className='leading-6 text-lg flex items-center justify-between'>
        {t('NamedValues.editValue')}
        <button onClick={onCancel} className='rounded-full p-2 hover:bg-gray-100 active:text-blue-500'>
          <XMarkIcon className='w-5 h-5 stroke-gray-500 active:stroke-blue-500' />
        </button>
      </Dialog.Title>
      <div className='pt-5 space-y-6'>
        <div className='space-y-1'>
          <label className='text-gray-500'>{t('NamedValues.name')}</label>
          <EditInput value={name} onSave={(value) => org && handleEditName(value)} />
        </div>
        <div className='space-y-1'>
          <label className='text-gray-500'>{t('NamedValues.value')}</label>
          <EditInput value={value} onSave={(value) => org && handleEditValue(value)} />
        </div>
      </div>
    </ModalDialog>
  )
}

export default EditNamedValueModal
